import { getUrl } from 'aws-amplify/storage';

const GetTeams = async (teams) => {
  try {
    const downloadResult = await getUrl({
      path: teams,
    });
    const text = await downloadResult.url;
    // console.log('All files:', filteredBodies);
    return text
  } catch (error) {
    console.error('Error fetching file URLs:', error);
    return [];
  }
};

export default GetTeams;